import Navigation from 'components/Navigation/Navigation';

import { Wrapper } from './Aside.styled';

export default function Aside() {
  return (
    <Wrapper>
      <Navigation />
    </Wrapper>
  );
}
